<template>
  <div class="financial-institution-selector">
    <el-select
      :value="value"
      class="mb-4"
      placeholder="เลือกสถาบันการเงิน"
      @input="handleChange"
    >
      <el-option
        v-for="f in financialInstitutions"
        :key="f.id"
        :label="f.name"
        :value="f.id"
      ></el-option>
    </el-select>
  </div>
</template>

<script>
import { Select, Option } from "element-ui"

export default {
  components: {
    "el-select": Select,
    "el-option": Option,
  },
  props: {
    value: {
      type: null,
      default: undefined,
    },
    financialInstitutions: {
      type: null,
      default: undefined,
    },
  },
  computed: {
    financialOptions() {
      if (!this.financialInstitutions) {
        return []
      }

      return this.financialInstitutions
    },
  },
  methods: {
    handleChange(value) {
      this.$emit("input", value)
    },
  },
}
</script>

<style lang="scss" scoped>
.financial-institution-selector {
  display: grid;
  grid-template-columns: 330px;
}
</style>
